/**
 * Pure utility functions with no external dependencies.
 * @module utils/helpers
 */

/**
 * Converts an ArrayBuffer to a base64-encoded string.
 * Processes in 8 KB chunks to avoid stack overflow on large buffers.
 * @param {ArrayBuffer} buffer
 * @returns {string} Base64 string
 */
export function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  const CHUNK = 8192;
  for (let i = 0; i < bytes.length; i += CHUNK)
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + CHUNK));
  return btoa(binary);
}

/**
 * Returns a promise that resolves after the given number of milliseconds.
 * @param {number} ms
 * @returns {Promise<void>}
 */
export function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Returns a human-readable description for a visibility level.
 * @param {string} visibility - "Public", "General", or "Confidential"
 * @returns {string}
 */
export function visibilityDetail(visibility) {
  switch (visibility) {
    case "Public":       return "Content visible to everyone, including the public (external to SBI)";
    case "General":      return "Content visible to all SBI employees (internal/external)";
    case "Confidential": return "Content strictly restricted to a predefined group";
    default:             return "";
  }
}
